import { FC } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';
import TextButton from './inputs/TextButton';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';

const MyTextButton = styled(TextButton)`
  margin: 0;
`;
interface Props {
  copyableText: string;
}

const CopyToClipboardIcon: FC<Props> = ({ copyableText }) => {
  const [, copy] = useCopyToClipboard();
  return (
    <MyTextButton
      onClick={async () => {
        await copy(copyableText);
        toast(`Kopierat ${copyableText} till urklipp`, { duration: 2000 });
      }}
    >
      <FontAwesomeIcon icon={faClone} title="Kopiera till urklipp" />
    </MyTextButton>
  );
};

export default CopyToClipboardIcon;
